/**
 * Heart-beat handler
 *
 * Sends a periodic health-check ping to the server.
 * Called by the auto-update / session watchdog to confirm the backend is reachable.
 *
 * Endpoint: GET /heartBeat
 */
import { getMethod } from "./rest-handler";

/**
 * Pings the server health-check endpoint.
 *
 * @returns A Promise that resolves when the server responds with 2xx, or rejects on network/HTTP error.
 */
export const heartBeat = () => {
  return new Promise<void>((resolve, reject) => {
    getMethod("heartBeat")
      .then((response) => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
};
